import { q1O } from '../util/nE'
import Flickity from 'flickity'
import gsap from 'gsap'
import state from '../state'
class LogoMarquee {
  constructor (el) {
    this.el = el
    this.list = this.el.querySelector('.logo-marquee__list')
    this.items = this.el.querySelectorAll('.logo-marquee__item')
    this.logos = this.el.querySelectorAll('.c-media-wrapper')
    this.speed = 0.7
  }

  init () {
    this.buildTimelineIn()
    this.buildFlickity()

    this.isXl = false
    const mm = gsap.matchMedia()
    mm.add(state.queries.xl, () => {
      this.isXl = true
    })

    if (this.isXl) {
      this.speed = 1.5
    }
  }

  buildTimelineIn () {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        duration: 1.5,
        ease: (t) => {
          return q1O(t)
        },
      },
    })

    tl.to(this.el, { autoAlpha: 1 })
  }

  buildFlickity () {
    this.flickity = new Flickity(this.list, {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
      imagesLoaded: true,
      draggable: false,
      freeScroll: true,
      freeScrollFriction: 0.03,
    })

    this.currentPosition = this.flickity.x
    gsap.ticker.add(this.onTick.bind(this))
  }

  onTick () {
    this.currentPosition += this.speed
    this.flickity.x = this.currentPosition
    this.flickity.settle(this.flickity.x)
  }

  destroy () {
    this.flickity.destroy()
    gsap.ticker.remove(this.onTick)
  }
}

export default LogoMarquee



//////////////////
// WEBPACK FOOTER
// ./scripts/components/LogoMarquee.js
// module id = 52
// module chunks = 0